import React, { useEffect } from "react";

function CSS(props) {

    const { prepend = false } = props;
    const css = props.html;
    const display = () => {
        return { __html: css };
    }


    useEffect(() => {

        if(prepend){

            let head = document.head || document.getElementsByTagName('head')[0],
            style = document.createElement('style');
            head.appendChild(style);
            style.type = 'text/css';
            style.appendChild(document.createTextNode(css));

        }
       

        

    }, []);
  
  

        return (<style dangerouslySetInnerHTML={display()}></style>);
}

export default CSS; 